import React, { useContext, useEffect, useRef, useState } from "react";
import clsx from "clsx";

import { viewportContext } from "../../../context/ViewportContext";

import UnitFilter from "../UnitFilter";
import FacilityFilter from "../FacilityFilter";
import RecordStatusFilter from "../RecordStatusFilter";
import DateFilter from "../DateFilter";
import { Grid, Paper, Typography } from "@mui/material";

import styles from "../../../styles.module.css";
import { Button } from "@material-ui/core";

const PatientCareDataFilters = ({
  facilities,
  setFacilities,
  selectedFacility,
  setSelectedFacility,
  selectedUnit,
  setSelectedUnit,
  units,
  setUnits,
  recordStatus,
  setRecordStatus,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  resetFilters,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const { screenType } = useContext(viewportContext);
  const paperRef = useRef(null);

  const handleClickOutside = (event) => {
    if (paperRef.current && !paperRef.current.contains(event.target)) {
      setShowFilter(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // list of filters to display
  const renderGrid = () => {
    return (
      <div style={{ marginTop: "10px" }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid
            item
            xs={12}
            sm={2}
            className={clsx(styles.flexCenter, styles.filterButtonMargin)}
          >
            <FacilityFilter
              selectedFacility={selectedFacility}
              setSelectedFacility={setSelectedFacility}
              facilities={facilities}
              setFacilities={setFacilities}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            className={clsx(styles.flexCenter, styles.filterButtonMargin)}
          >
            <UnitFilter
              selectedUnit={selectedUnit}
              setSelectedUnit={setSelectedUnit}
              units={units}
              setUnits={setUnits}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={2}
            className={clsx(styles.flexCenter, styles.filterButtonMargin)}
          >
            <RecordStatusFilter
              recordStatus={recordStatus}
              setRecordStatus={setRecordStatus}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            className={clsx(styles.flexCenter, styles.filterButtonMargin)}
          >
            <DateFilter
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <Paper className={styles.paperStyles}>
      {screenType.isMobile ? (
        <>
          <div className={styles.filterRow}>
            <Typography variant="h5">Filters</Typography>
            <Button
              className={styles.secondaryButton}
              onClick={() => setShowFilter(!showFilter)}
            >
              Filters
            </Button>
          </div>
          {showFilter && (
            <Paper ref={paperRef} className={styles.filterPaperStyles}>
              {renderGrid()}
            </Paper>
          )}
        </>
      ) : (
        <>
          <div className={styles.filterRow}>
            <Typography variant="h5">Filters</Typography>
            <Button
              className={styles.secondaryButton}
              onClick={() => resetFilters()}
            >
              Reset Filters
            </Button>
          </div>
          {renderGrid()}
        </>
      )}
    </Paper>
  );
};

export default PatientCareDataFilters;
